import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { Perk } from 'src/app/interfaces/perk';
import { PerkService } from '../perk/perk.service';

@Injectable({
  providedIn: 'root'
})
export class PerksResolverService  {

  constructor(private perkService: PerkService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Perk> | Promise<any> | any {
    if (route.parent.data.user) {
      return this.perkService.getPerks(route.parent.data.user);
    }
  }
}
